import React, { Component } from 'react';
export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsChecked extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsChecked: "/api/v1/portal/jobs/mark-as/toggle/checked/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }
  toggleMarkJobAsChecked() {
    return fetch(
      this.state.apiUrlForToggleMarkJobAsChecked+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }
  render() {
    return(
      <span> {(
        (this.state.data.checked === 1) &&
        (this.state.data.checked_by) &&
        (this.state.data.checked_by.first_name)) ?
        <p><button className="btn btn-lg btn-success">
          Job Checked (by {this.state.data.checked_by.first_name
        }&nbsp;{this.state.data.checked_by.last_name} on {
          this.state.data.checked_at
        })
        </button>&nbsp;
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-green"
            title={"Toggle Mark Job as: JOB IS READY TO SEND"+
            "TO DRIVER OR OUTSOURCED"}
            onClick={(e) => this.toggleMarkJobAsChecked(e)}
          >
            <i className="fa fa-undo"></i>&nbsp;
            Unmark Job As Checked
          </button></p>
        :
        <p>Job Not Checked<br />
        <button
        className="btn btn-lg btn-dark job-row-highlighter-option-green"
        title={"Toggle Mark Job as: JOB IS READY TO SEND"+
        "TO DRIVER OR OUTSOURCED"}
        onClick={(e) => this.toggleMarkJobAsChecked(e)}
        >
        Mark Job As Checked
        </button></p>
      }
    </span>
    )
  }
}